import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Daytrip() {



    const cardData =
    {
        keyword: 'Day Trip Destinations Near Morachi Chincholi Pune',
        heading: 'Anand Krushi Paryatan Kendra: Day Trip Destinations Near Morachi Chincholi Pune',
        headingDescription: 'If you are visiting Morachi Chincholi and looking to explore beyond, there are several exciting day trip destinations near Morachi Chincholi Pune that offer a perfect mix of history, spirituality, and natural beauty. Just a short drive away, you can visit the iconic Shivneri Fort, the birthplace of Chhatrapati Shivaji Maharaj, or marvel at the natural rock formations at Nighoj Potholes, a rare geological site carved by the Kukadi River. The revered Ranjangaon Mahaganpati Temple, one of the Ashtavinayak pilgrimage sites, is also nearby and makes for a peaceful spiritual stop. For those seeking a scenic hilltop view and ancient temple architecture, the Bhuleshwar Temple is a must-visit. These spots make excellent add-ons to your Morachi Chincholi trip, creating a memorable one-day rural getaway from Pune. Whether you are a nature lover, history buff, or spiritual seeker, these nearby destinations enrich your countryside experience.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Lenyadri Caves",
    "description": "Located about 29 km from Morachi Chincholi, Lenyadri Caves are a group of ancient rock-cut Buddhist caves and one of the Ashtavinayak Ganesh temples. A mix of spiritual significance and heritage exploration makes it a must-visit destination."
  },
  {
    "title": "Ranjangaon Mahaganpati Temple",
    "description": "Around 20 km away, this revered Ashtavinayak temple dedicated to Lord Ganesha is known for its majestic architecture and serene spiritual atmosphere. It’s a perfect stop for religious travelers and heritage seekers."
  },
  {
    "title": "Shivneri Fort – Birthplace of Shivaji Maharaj",
    "description": "Just over an hour’s drive from Morachi Chincholi lies Shivneri Fort near Junnar – the birthplace of Chhatrapati Shivaji Maharaj. Explore ancient fortification, water cisterns, and breathtaking valley views steeped in Maratha history."
  },
  {
    "title": "Takali Dhokeshwar Temple",
    "description": "This serene hilltop temple dedicated to Lord Shiva offers a peaceful vibe and panoramic views of the surrounding countryside. Located around 25 km from Morachi Chincholi, it’s ideal for quiet morning or evening visits."
  },
  {
    "title": "Tulapur – Samadhi of Sambhaji Maharaj",
    "description": "Located on the banks of the Bhima River, Tulapur is a historical site where Sambhaji Maharaj was martyred. The tranquil village features a Samadhi temple and is rich in Maratha legacy, just under 40 km away."
  },
  {
    "title": "Narayanpur Balaji Temple",
    "description": "A serene temple dedicated to Lord Venkateshwara near Saswad, this place offers a spiritual South Indian temple experience. Though slightly farther (~60–70 km), it’s a worthwhile peaceful day trip."
  },
  {
    "title": "Pabal Jain Temple & Mastani Samadhi",
    "description": "Located around 20 km away, this Jain pilgrimage site and nearby memorial of Mastani Bai (beloved of Bajirao Peshwa) offers both religious significance and Mughal-Maratha historical intrigue."
  },
  {
    "title": "Bhuleshwar Temple",
    "description": "An artistic and mysterious Shiva temple around 50 km from Morachi Chincholi, known for its fusion of Indo-Islamic architecture, mythological carvings, and mystical ambience. Perfect for heritage photography and calm exploration."
  },
  {
    "title": "Morgaon Mayureshwar Temple",
    "description": "Part of the Ashtavinayak pilgrimage route, this temple is approximately 55–60 km from Morachi Chincholi and is surrounded by peacock-populated grasslands. Ideal for religious devotees and nature lovers alike."
  },
  {
    "title": "Panshet Dam (Extended Drive)",
    "description": "Though about 70–80 km away, Panshet Dam is worth the extended drive for boating, photography, and lakeside relaxation surrounded by forested hills. Ideal for couples and weekend nature enthusiasts."
  }
],




"services": [
  {
    "name": "Popular Day Trips from Morachi Chincholi",
    "description": "Anand Krushi Paryatan Kendra is a popular choice for a full-day rural retreat near Morachi Chincholi. It offers families and travelers an authentic village experience with activities like bullock cart rides, farm exploration, and traditional cooking—all packed into a refreshing one-day visit."
  },
  {
    "name": "Nature Day Trips Near Pune",
    "description": "Looking for a peaceful nature-filled escape near Pune? Anand Krushi Paryatan Kendra invites you into its green expanse of orchards, seasonal crops, and peacock-friendly zones, making it a perfect spot for a rejuvenating day surrounded by nature."
  },
  {
    "name": "Family Day Outings Near Morachi Chincholi",
    "description": "Families love Anand Krushi Paryatan Kendra for its safe and engaging environment. Kids can feed farm animals, enjoy rural games, and learn about local agriculture, while adults relax with traditional meals and scenic farm views. It’s a wholesome day outing for all ages."
  },
  {
    "name": "Adventure Day Trips Near Pune",
    "description": "If you're craving a different kind of adventure, Anand Krushi Paryatan Kendra offers field-based thrills like tractor rides, rope balancing, and rural sports. It’s a light-adventure destination near Pune that blends excitement with the essence of countryside living."
  },
  {
    "name": "Relaxing Day Trips Near Morachi Chincholi",
    "description": "Escape the stress of the city with a relaxing day trip to Anand Krushi Paryatan Kendra. Surrounded by farmland, chirping birds, and gentle breezes, it's an ideal setting for unwinding—complete with shaded rest spots, hammocks, and fresh farm meals."
  },
  {
    "name": "Heritage Sites for Day Trips",
    "description": "Plan a day that combines history and nature by visiting nearby heritage sites like Shivneri Fort or Bhuleshwar Temple, followed by a relaxing break at Anand Krushi Paryatan Kendra. It’s the perfect balance of exploration and rural tranquility."
  },
  {
    "name": "Waterfall Visits Near Morachi Chincholi",
    "description": "During the monsoon, Anand Krushi Paryatan Kendra can be paired with short drives to nearby waterfalls. Enjoy the cool spray of cascading waters and return to the farm for a warm, traditional meal and a restful rural experience."
  },
  {
    "name": "Wildlife Parks Near Pune",
    "description": "Although not a traditional wildlife park, Anand Krushi Paryatan Kendra is located near natural birdwatching areas and farms teeming with peacocks, kingfishers, and other birds—offering a soft wildlife experience close to Morachi Chincholi."
  },
  {
    "name": "Historical Forts Near Morachi Chincholi",
    "description": "Combine your visit to Anand Krushi Paryatan Kendra with a morning trek to forts like Shivneri or Rajgad. After a dose of history and scenic views, head to the farm to rest, refuel with local food, and reconnect with village simplicity."
  },
  {
    "name": "Hill Stations Near Pune",
    "description": "While Morachi Chincholi itself lies in the plains, Anand Krushi Paryatan Kendra can be a peaceful stopover en route to nearby hill stations like Lonavala or Malshej Ghat. Recharge in a rustic setting before heading to the hills."
  },
  {
    "name": "Trekking Day Trips Near Morachi Chincholi",
    "description": "Adventure-seekers can enjoy a day of trekking around nearby hills or heritage sites and then wind down at Anand Krushi Paryatan Kendra. The farm offers rest, food, and peaceful surroundings—perfect after a morning on the trail."
  },
  {
    "name": "Eco-Tourism Day Trips Near Pune",
    "description": "Anand Krushi Paryatan Kendra is a model for eco-tourism near Pune. Visitors learn about organic farming, composting, water conservation, and local biodiversity, all while enjoying hands-on experiences and delicious farm meals."
  },
  {
    "name": "Bird Watching Day Trips Near Morachi Chincholi",
    "description": "Morachi Chincholi is famous for peacocks, and Anand Krushi Paryatan Kendra provides a quiet, natural environment to spot these majestic birds. Bring your camera and binoculars—it’s a birdwatcher’s delight, especially in the early morning."
  },
  {
    "name": "Picnic Spots for Day Trips",
    "description": "Pack your spirit of fun and head to Anand Krushi Paryatan Kendra for a day picnic. With shaded seating, play areas, and traditional food, it’s an ideal spot for families, school trips, or couples seeking a calm, nature-filled day."
  },
  {
    "name": "Farm Visits Near Morachi Chincholi",
    "description": "Anand Krushi Paryatan Kendra offers a full farm visit experience—plucking vegetables, feeding livestock, and understanding traditional irrigation methods. It’s a rare, enriching opportunity for urban visitors to get their hands dirty in the best way possible."
  }
],
"tableData": [
  ["Popular Day Trips from Morachi Chincholi", "- Nature Day Trips Near Pune"],
  ["Family Day Outings Near Morachi Chincholi", "- Adventure Day Trips Near Pune"],
  ["Relaxing Day Trips Near Morachi Chincholi", "- Heritage Sites for Day Trips"],
  ["Waterfall Visits Near Morachi Chincholi", "- Wildlife Parks Near Pune"],
  ["Historical Forts Near Morachi Chincholi", "- Hill Stations Near Pune"],
  ["Trekking Day Trips Near Morachi Chincholi", "- Eco-Tourism Day Trips Near Pune"],
  ["Bird Watching Day Trips Near Morachi Chincholi", "- Picnic Spots for Day Trips"],
  ["Farm Visits Near Morachi Chincholi", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Shirur Fort",
    "WhyChoosedescription": "Located about 20 km from Morachi Chincholi, Shirur Fort is a historic site offering panoramic views of the surrounding countryside. It’s a peaceful spot for history lovers and nature enthusiasts alike."
  },
  {
    "WhyChooseheading": "Nighoj Caves and Jain Temple",
    "WhyChoosedescription": "About 25 km away, Nighoj is famous for its unique pothole formations and an ancient Jain temple. It’s a great destination for geology buffs and those interested in spiritual heritage."
  },
  {
    "WhyChooseheading": "Ramling Mandir",
    "WhyChoosedescription": "Situated approximately 30 km from Morachi Chincholi, Ramling Mandir is a revered Shiva temple. The calm and spiritual atmosphere makes it a perfect place for a serene visit."
  },
  {
    "WhyChooseheading": "Mallikarjun Temple",
    "WhyChoosedescription": "About 35 km away, Mallikarjun Temple is known for its traditional architecture and peaceful surroundings. It’s ideal for travelers seeking spiritual solace close to nature."
  },
  {
    "WhyChooseheading": "Vadgaon Dam",
    "WhyChoosedescription": "Located near Shirur, Vadgaon Dam is a tranquil spot surrounded by greenery. It’s perfect for picnics, relaxing by the water, and enjoying nature."
  },
  {
    "WhyChooseheading": "Loni Kalbhor",
    "WhyChoosedescription": "Around 40 km from Morachi Chincholi, Loni Kalbhor offers peaceful countryside views and local cultural experiences, great for those looking to explore rural Maharashtra."
  }
]






    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'What are some popular day trip destinations near Morachi Chincholi?',
    answer: 'Popular day trips include Anand Krushi Paryatan Kendra, Ranjangaon Ganpati Temple, Alandi, Shikrapur village, and the peacock sanctuary itself.',
  },
  {
    id: 'FAQ2',
    question: 'How far is Ranjangaon Ganpati Temple from Morachi Chincholi?',
    answer: 'Ranjangaon Ganpati Temple is approximately 25 km from Morachi Chincholi, about a 30-minute drive.',
  },
  {
    id: 'FAQ3',
    question: 'Can I visit Anand Krushi Paryatan Kendra on a day trip?',
    answer: 'Yes! Anand Krushi is perfect for a half-day or full-day visit with activities like pony rides, tractor rides, and nature walks.',
  },
  {
    id: 'FAQ4',
    question: 'Are there any nature trails near Morachi Chincholi?',
    answer: 'Yes, the area around Morachi Chincholi offers several walking trails where you can enjoy birdwatching, peacock sightings, and farm landscapes.',
  },
  {
    id: 'FAQ5',
    question: 'Is public transport available to these destinations?',
    answer: 'Public transport options are limited, so private vehicles or taxis are recommended for ease of travel between destinations.',
  },
  {
    id: 'FAQ6',
    question: 'Are food and refreshments available at these spots?',
    answer: 'Anand Krushi has a snack counter, and local eateries are available near Ranjangaon and Alandi. Carrying water and snacks is advised for nature trails.',
  },
  {
    id: 'FAQ7',
    question: 'What is the best time to visit these destinations?',
    answer: 'Monsoon to early winter (June to November) is the best time for pleasant weather and active peacock sightings.',
  },
  {
    id: 'FAQ8',
    question: 'Can I combine these destinations in a single day trip?',
    answer: 'Yes, a well-planned itinerary can include Anand Krushi, Ranjangaon Ganpati Temple, and Alandi in a single day.',
  },
  {
    id: 'FAQ9',
    question: 'Are there guided tours available for these day trips?',
    answer: 'Some local operators offer guided tours that include visits to Anand Krushi and nearby temples, as well as cultural insights.',
  },
  {
    id: 'FAQ10',
    question: 'Is it suitable for families and groups?',
    answer: 'Definitely. These destinations cater well to families, school groups, and tourists looking for nature, culture, and relaxation close to Pune.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Kulkarni, Pune',
    feedback: "Our day trip around Morachi Chincholi was fantastic. We started with a visit to Ranjangaon Temple, then enjoyed pony rides and butterfly watching at Anand Krushi. A memorable experience for all ages!",
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Shah, Mumbai',
    feedback: "Loved the blend of culture and nature around Morachi Chincholi. The trip was well-paced, and the local guides added great insights. Perfect day trip from Pune.",
    rating: 5,
  },
];






    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Day Trip Destinations Near Morachi Chincholi Pune",
  "image": "https://morachichincholi.in/assets/images/day-trip-destinations-near-morachi-chincholi.jpg",
  "description": "Plan perfect day trips from Morachi Chincholi near Pune, featuring nature trails, waterfalls, heritage forts, wildlife parks, and farm visits. Enjoy adventure or relaxing outings with Anand Krushi Paryatan Kendra as your base.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "2011"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "500",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/day-trip-destinations-near-morachi-chincholi"
  }
};


    return (
        <div>
<Helmet>
  <title>Day Trip Destinations Near Morachi Chincholi Pune | Nature, Heritage & Family Fun | Anand Krushi Paryatan Kendra</title>
  <meta 
    name="description" 
    content="Explore day trip destinations near Morachi Chincholi Pune – from nature parks and waterfalls to forts, wildlife zones, and farm experiences. Perfect for families, nature lovers, and adventure seekers. Stay at Anand Krushi Paryatan Kendra." 
  />
  <meta 
    name="keywords" 
    content="Popular day trips from Morachi Chincholi, Nature day trips near Pune, Family day outings near Morachi Chincholi, Adventure day trips near Pune, Relaxing day trips near Morachi Chincholi, Heritage sites for day trips, Waterfall visits near Morachi Chincholi, Wildlife parks near Pune, Historical forts near Morachi Chincholi, Hill stations near Pune, Trekking day trips near Morachi Chincholi, Eco-tourism day trips near Pune, Bird watching day trips near Morachi Chincholi, Picnic spots for day trips, Farm visits near Morachi Chincholi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/5.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Daytrip;